var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.456 2.407 28.25 8.034c1.135.591 1.154 1.612.043 2.278l-1.963 1.176-.747.447-.747.448-4.351 2.607-.747.447-.747.448-1.263.757c-.599.359-1.404.542-2.196.542-.678 0-1.349-.134-1.873-.407l-1.534-.8-.773-.403-.772-.403-4.3-2.24-.773-.403-.772-.403-1.869-.974c-1.135-.592-1.154-1.612-.043-2.278l10.567-6.33C13.986 2.182 14.79 2 15.583 2c.68 0 1.35.134 1.873.407zM28.25 14.108l-1.87-.991-4.35 2.653-.747.455-.747.456-2.037 1.243c-.813.496-1.868.768-2.97.768-.955.001-1.842-.202-2.567-.586l-2.334-1.239-.773-.409-.773-.41-4.3-2.282-1.963 1.197c-1.11.68-1.091 1.717.044 2.32l2.244 1.19.773.41.773.41 7.004 3.716c.524.278 1.195.414 1.874.414.793 0 1.598-.186 2.197-.55l6.734-4.107.748-.455.747-.456 2.338-1.425c1.111-.678 1.092-1.716-.043-2.319zM15.495 24.93c-.953 0-1.838-.2-2.561-.577l-7.783-4.07-2.33 1.402c-1.11.666-1.09 1.687.042 2.28l10.765 5.627c.522.274 1.19.408 1.868.408.79 0 1.593-.183 2.19-.542l10.539-6.333c1.108-.666 1.089-1.687-.044-2.278l-2.238-1.171-7.487 4.5c-.81.486-1.861.754-2.96.754z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuse);
export default __webpack_public_path__ + "static/media/FUSE.ea3e30d9f9f6c54cc07aa3a23daa2b86.svg";
export { ForwardRef as ReactComponent };